import * as React from 'react';
import Immutable from 'immutable';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink, Webform } from '@uncinc/react-drupal-core';

import { Button } from '../../components';
import webform from './webform.json';

import './style.scss';

const DesignSystem: React.FC = () => (
  <Container>
    <h1>Design system</h1>
    <h2>Buttons and links</h2>
    <div className="ButtonsWrapper">
      <Button type="primary" to="/">Primary button</Button>
      <Button type="secondary" to="/">Secondary button</Button>
      <Button type="inverted" to="/">Ghost button</Button>
      <CoreLink to="/">Default link</CoreLink>
      <CoreLink to="/" className="icon-after icon-chevron-right">Link with icon</CoreLink>
    </div>
    <h2>Buttons and links (disabled)</h2>
    <div className="ButtonsWrapper">
      <Button type="primary" to="/" disabled>Primary button</Button>
      <Button type="secondary" to="/" disabled>Secondary button</Button>
      <Button type="inverted" to="/" disabled>Ghost button</Button>
    </div>
    <h2>Webform</h2>
    <Webform entities={Immutable.fromJS(webform)} includeFieldSets />
  </Container>
);

export default DesignSystem;
